import { Button, Group, Modal, Stack, Text, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { IconUpload } from '@tabler/icons-react'
import { type FC } from 'react'

export interface PhotoSaveConfirmModalProps {
  count: number
  onCancel: () => void
  onConfirm: () => void
  opened: boolean
}

export const PhotoSaveConfirmModal: FC<PhotoSaveConfirmModalProps> = ({ count, onCancel, onConfirm, opened }) => {
  const theme = useMantineTheme()
  const fullScreen = !!useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)

  return (
    <Modal
      centered
      fullScreen={fullScreen}
      onClose={onCancel}
      opened={opened}
      title='Upload photos?'
    >
      <Stack>
        <Text size='sm'>
          {count === 1
            ? 'You are about to upload 1 photo. It will be marked Pending Review until DPP staff approves it.'
            : `You are about to upload ${count} photos. They will be marked Pending Review until DPP staff approves them.`}
        </Text>
        <Group position='right' spacing='xs'>
          <Button onClick={onCancel} variant='default'>Cancel</Button>
          <Button color='green.8' leftIcon={<IconUpload size={18} />} onClick={onConfirm}>
            Upload
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
